import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { Icon } from '../../../../../../ui/components/Icon'
import { EmptyCartIcon } from './EmptyCartIcon'

export const EmptyCart = () => {
  return (
    <div
      className={csx({
        height: '80%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        transform: 'translateY(-$space-8)',
        zIndex: -1,
      })}
    >
      <Icon
        className={csx({
          width: '8.125rem',
          height: '8.125rem',
        })}
      >
        <EmptyCartIcon />
      </Icon>
      <Text variant="action1">
        <FormattedMessage id="checkout.empty-cart-state.title" />
      </Text>
      <Text
        variant="detail"
        tone="secondary"
        className={csx({
          marginTop: 1,
          maxWidth: '11.25rem',
          textAlign: 'center',
        })}
      >
        <FormattedMessage id="checkout.empty-cart-state.subtitle" />
      </Text>
    </div>
  )
}
